var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 568,
    viewBox: "0 0 568 568",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.673 67.3333H140.673C103.336 67.3333 84.654 67.3333 70.3933 74.5997C57.849 80.991 47.6577 91.1823 41.2663 103.727C34 117.987 34 136.67 34 174.007V427.34C34 464.677 34 483.337 41.2663 497.597C47.6577 510.14 57.849 520.35 70.3933 526.74C84.64 534 103.3 534 140.564 534H394.103C431.367 534 450 534 464.247 526.74C476.79 520.35 487.017 510.13 493.407 497.587C500.667 483.34 500.667 464.7 500.667 427.437V367.333M534 200.667V34M534 34H367.333M534 34L300.667 267.333",
    stroke: "#3C64B1",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/External_Link.4129d12c0d8c805eb28fc2341732646b.svg";
export { ForwardRef as ReactComponent };